import React from 'react';
import ReactDOM from "react-dom/client";
import coreSettings from '../helpers/default-settings.js'
import constants from '../helpers/constants.js';
import MDTNotification from '../components/molecules/mdt-notification/index.js';
import MDTTimerNotification from '../components/molecules/mdt-timer-notification/index.js';
import { uniqueId, get, isArray, every, isString, has, isEmpty, isNull,  } from 'lodash';
import jwt_decode from 'jwt-decode';
import { MDTApi } from '../services/mdtapi.js';
import { MDTAnalytics } from '../services/mdtanalytics.js';
import { loadInit, userpermissionsCheck, checkResourceRights, handleRefreshSuccess, restartRefreshTimer, featureConfiguration } from '../actions/MeActions.js';
import { getAddressFormatConfiguration } from '../actions/configurationActions.js'
import { getReturnsCart } from '../actions/returnActions.js';

window.MDTSetting = window.MDTSetting || {};
//exposing register settings to support legacy bu-settings

window.MDTApp = {};
window.MDTApp.registerSettings = function(response){
    MDTSetting = mergeDeep(MDTSetting, response);
    MDTSetting.pathVars = response || {};
    MDTApi.setDefaultPathVar("appid", MDTSetting.appid);
}

let riotIsInit = false,
    translations = {},
    dateConfig = {},
    numberConfig = {},
    loginPopin = false,
    SSOclick = true;
// Private (NON-Export )function

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}

function idleLogout() {
    let t;
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener('scroll', resetTimer);

    function notifyUser() {
        window.removeEventListener('scroll', resetTimer);
        window.removeEventListener('mousemove', resetTimer);
        window.removeEventListener('keydown', resetTimer);
        showNotification(window.t("sessionTimeOutMessage"), "information", window.t("SessionTimeOut"), window.t("Ok"), function () {
            window.location.reload();
        }, {
                timer: MDTSetting.sessionTimoutTimer || 60,
                sessionTimeOutCallBack: () => {
                    logout();
                },
                unit: window.t("seconds")
            });
    }

    function resetTimer() {
        clearTimeout(t);

        t = setTimeout(notifyUser, MDTSetting.idleTime || 1800000); // time is in milliseconds
    }
}

let xhrNotifyElement = null
function showNotification(msg, type, title, buttonLevel, callback, sessionTimeOutNotification) {
    if (!msg) {
        console.log("Notification Message should not be undefined.....................");
        return;
    }

    let props = {
        contents: [msg],
        defaultOpen: true,
        button: buttonLevel || "",
        notifyType: type || "error",
        title: title,
        key: uniqueId('id_')


    };
    if (callback) props.toggle = callback;
    let elementName = "xhrNotify";
    let element = document.getElementById(elementName);

    if (!element) {
        element = document.createElement("div");
        element.setAttribute("id", "xhrNotify");
        document.body.appendChild(element);
    }
    if (!xhrNotifyElement) {
        xhrNotifyElement = ReactDOM.createRoot(document.getElementById(elementName));
    }

    // TODO: Refactor this, add <MDTTimerNotification /> to the
    //  skeleton and write here to redux just if it should
    //  be shown or not  20231027:Alevale
    if (sessionTimeOutNotification) {
        let timerNoficationProps = { ...props, timer: sessionTimeOutNotification.timer, timerCallback: sessionTimeOutNotification.sessionTimeOutCallBack, unit: sessionTimeOutNotification.unit }
        xhrNotifyElement.render(<MDTTimerNotification {...timerNoficationProps} />);
    } else {
        xhrNotifyElement.render(<MDTNotification {...props} />);
    }
}

function registerSettings(resolve) {
    MDTSetting = mergeDeep(MDTSetting, coreSettings);
    return getAppSettings(resolve);
}


    function getAppSettings(resolve) {
        let appSettings = window.appSettings;
        MDTSetting = mergeDeep(MDTSetting, appSettings);

        getSetting('fetchApiConfg', false) && registerAppApiSettings();
        getSetting('configurationServerEnabled', false) && registerConfigServerApiSettings();
        return resolve();
    }

    function registerAppApiSettings(resolve) {

        return MDTApi.call('appApi', {
            method: 'GET',
            cache: true,
            headers: { "Authorization": 'no auth' },
            errorCallback: handleError,
            successCallback: function(data) {
                window.MDTSetting = mergeDeep(MDTSetting, data);
                // registerBuSettingSuccess(data);
                //return resolve();
            }
        });

    }
    function registerConfigServerApiSettings() {
        MDTApi.setDefaultPathVar("appid", MDTSetting.appid);
        MDTApi.setDefaultPathVar("env", MDTSetting.features.environment);
        return MDTApi.call('api.configServer', {
            method: 'GET',
            cache: true,
            // headers: { "Authorization": 'no auth' },
            errorCallback: handleError,
            successCallback: function(data) {
                let configs;
                configs =Object.assign(...data.propertySources.map((i)=> i.source));
                window.MDTSetting = mergeDeep(MDTSetting, configs);
            }
        });
    }
    function handleError(error) {
        console.log("error");
    }

    function handleResponse(response) {
        console.log("response...")
    }

    function registerBuSettingSuccess(response) {
        MDTSetting = mergeDeep(MDTSetting, response);
        MDTSetting.pathVars = response || {};
        MDTApi.setDefaultPathVar("appid", MDTSetting.appid);
    }

    /* TO DO:  Enable this feature latter  */
    // function getFeatureVersionSuccess(data) {
    //     return { type: constants.GET_FEATURE_VERSION, data };


    // }

    // function getFeatureVersion() {

    //     return MDTApi.call('featuresSettings', {
    //         method: 'GET'
    //     });
    // }

    //Public (Export) function
    function getResourceAccess(resourceName, resourcePermission) {
        return (dispatch, getState) => {
            const resource = get(getState(), 'meDetails.resourceAccess', []);
            return resource.length > 0 && !!resource.find(obj => obj.resource === resourceName && obj.actions.includes(resourcePermission));
        }
    }

    function createQueryStringParam(object) {

        return Object.keys(object).map((key) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent(object[key]);
        }).join('&');
    }

    function initBootstrap(resolveStore) {

        return (dispatch, getState) => {
            new Promise(function(resolve, reject) {
                    registerSettings(resolve)
                }).then(function(result) {
                    return new Promise((resolve, reject) => {
                        dispatch(loadInit(resolve));
                    });
                }).then(function(result) {
                    dispatch(authenticate());
                }).then(function(result) {
                    return new Promise((resolve, reject) => {
                        dispatch(getPermissions(resolve));
                    });
                }).then(function(result) {
                    checkBrowserSupport();
                    let fetchConfig = getSetting('login.fetchConfig', true);
                    fetchConfig && dispatch(fetchConfiguration());

                }).then(function() {
                    const customerId = get(getState(), 'meDetails.defaultCustomer.id', undefined);
                    const me = getState().meDetails && getState().meDetails.meState;
                    const isLoggedIn = me.LOGGED_IN;
                    if(customerId){
                        // For Consignment_Purchaser user role, ZOR ordertype will be change to KB ordertype so sending customerId to get configuration.
                        dispatch(featureConfiguration(customerId))
                        .then(result=>{
                            // getSetting('login.autofetchWishlist', true) && dispatch(getResourceAccess('Cart', 'Write')) && dispatch(fetchWishlist());
                            if(getSetting('login.autofetchWishlist', true) && dispatch(getResourceAccess('Cart', 'Write'))){
                                return new Promise((resolve, reject) => {
                                    dispatch(fetchWishlist(resolve));
                                });
                            }
                        });

                    } else {
                        // NOTE: If the APP doesn't have a customer it could still have configuration, so call it 20220609:Alevale
                        if (isLoggedIn) {
                            return new Promise((resolve, reject) => {
                                dispatch(featureConfiguration()).then(res => {
                                    return resolve();
                                });
                            });
                        }
                        
                    }
                    isLoggedIn && idleLogout();
                 
                })
                .then(function() {
                    if (resolveStore)
                        return resolveStore();
                })
                .then(function() {
                    let territoryId = getState()?.meDetails?.customer?.territory?.id || 'default',
                    addressFormat  = getSetting('login.addressFormat', true);
                    //added confg setting to turn off addressFormat API 
                    addressFormat && dispatch(getAddressFormatConfiguration(territoryId));
                    dispatch(MDTAnalytics.cacheUser(getDeviceType()));
                });
        }
    }

    function requestXHR() {

        return { type: constants.XHR_CALL_INPROGRESS };

    }

    /**
     * Deep merge two objects.
     * @param target
     * @param ...sources
     */
    function mergeDeep(target, ...sources) {

        if (!sources.length) return target;
        const source = sources.shift();

        if (isObject(target) && isObject(source)) {
            for (const key in source) {
                if (isObject(source[key])) {
                    if (!isObject(target[key])) Object.assign(target, {
                        [key]: {}
                    });
                    mergeDeep(target[key], source[key]);
                } else {
                    Object.assign(target, {
                        [key]: source[key]
                    });
                }
            }
        }

        return mergeDeep(target, ...sources);
    }




    function getSetting(key, defaultValue, flatProcessUrl) {
        let collection = MDTSetting;

        if (typeof key != "string") {
            console.error('MDTApp.getSetting: parameter must be a string');
            return undefined;
        }
        let arPath = key.split('.');
        let result = collection;
        for (let i = 0; i < arPath.length; i++) {
            if (result[arPath[i]] !== undefined) {
                result = result[arPath[i]];
            } else {
                return defaultValue || false;
            }
        }

        if (flatProcessUrl) {
            return MDTApi.processPathVariables(result, MDTSetting.pathVars);
        }

        return result;
    }


    function getSettingObjectByKey(currentStore, key) {

        //let currentStoreObj = currentStore.getState().bootDetails.settings;
        return getSetting(key);

    }



    function loadFeatureFlags() {
        return (dispatch, getState) => {
            //const intialState = getState().bootDetails.settings;
            let featureFlagsEnabled = getSetting('featureFlagsEnabled');
            let appId = getSetting('layout.sidebar');
            if (featureFlagsEnabled) {
                console.log('init', appId, 'loading feature flags...');

                return getFeatureVersion().then(data => {
                    dispatch(getFeatureVersionSuccess(data));
                }).catch(error => {
                    throw (error);
                }).then(data => {
                    const currentState = getState();
                    //return initializeToken(dispatch,getState)
                })
            }

        }
    }

    const whitelistedUrl = (location) => {
        // NOTE: We rely on the routemap to see if the page is accessible.
        // When the page was defined with "externallyAccessible: true" then
        // we don't make a redirect to the login 20201201:Alevale
        return get(location.routesMap, `${ location.type }.externallyAccessible`, false);

    }

    function authenticate() {
        //let deferred = new $.Deferred();
        return (dispatch, getState) => {
            const location = getState().location || {};
            let currentLocation = location.routesMap.catalog;
            let home = location.routesMap.home || "/";
            let prevPath = location.prev.pathname || home;

            let appId = getSetting('appid');
            let requiresAuthentication = getSetting('login.autoCheckLogin', true);
            let me = getState().meDetails.meState || {};
            let isLoginPage = getQueryStringParam("login", currentLocation, false);

            if (whitelistedUrl(location)) {
                return
            }

            if (requiresAuthentication) console.log('init', appId, 'authenticating...');
            let redirection = location.type == "LOGIN" || location.type == "FORGOTPASSWORD" || location.type == "REQUESTACCESS" ? "PORTAL" : location.type
            if ((location.type == "LOGIN" || location.type == "FORGOTPASSWORD" || location.type == "REQUESTACCESS") && me.LOGGED_IN) {
                //  goto(getSetting(prevPath));
                dispatch({ type: redirection })

            } else if (requiresAuthentication && !me.LOGGED_IN && !isLoginPage) {
                redirection = location.type != "LOGIN" || location.type != "FORGOTPASSWORD" || location.type != "REQUESTACCESS" ? "LOGIN" : location.type
                const queryParams = getState().location?.query;
                dispatch({ type: redirection, query:queryParams }) 
            }
        }

    }

    function isAvilable(state, meState) {
        if (!isArray(state)) state = [state];
        return state.length && every(state, function(s) {
            return isString(s) && !!meState[s];
        });

    }

    function getPermissions(resolve) {
        return (dispatch, getState) => {
            let requiresAuthorization = getSetting('login.autoCheckPermissions', true);
            let appId = getSetting('appid');
            let buId = getSetting('buid');
            let me = getState().meDetails.meState || {},
                loggedIn = me.LOGGED_IN;

            function inAcceptingState() {
                return !requiresAuthorization || isAvilable(me.HAS_PERMISSIONS, me);
            }

            if (!inAcceptingState() && !isAvilable(me.FETCHING_PERMISSIONS, me) && loggedIn) {
                dispatch(userpermissionsCheck(dispatch, getState, resolve, appId, buId));
            } else {
                resolve && resolve(getState);
            }
        }

        //return deferred.promise();
    }


    function fetchConfiguration() {
        return (dispatch, getState) => {
            let defaultCustomer = getState().meDetails.defaultCustomer || {};
            if (defaultCustomer.territory) {
                MDTApi.setDefaultPathVar("supplierId", defaultCustomer.territory.id || '');
            }
            return MDTApi.call('api.configurations.all', {
                method: 'GET',
                successCallback: function(data) {
                    dispatch(storeConfigData(data));
                }
            });

        }
    }

    // function getMessages() {
    //     return (dispatch, getState) => {
    //         const params = { application: MDTSetting.name };
    //         const pageName = getState().page;
    //         const me = getState().meDetails.meState || {},
    //             loggedIn = me.LOGGED_IN;
    //         if (loggedIn) {
    //             const userid = getState().meDetails.user || {};
    //             MDTApi.call('api.common.manageMessages', {
    //                 method: 'GET',
    //                 params,
    //                 successCallback: (data) => showMangemessagesToast(data, pageName),
    //                 errorCallback: () => {}
    //             }, {
    //                 userid: userid.sub
    //             });
    //         }
    //     }
    // }

    function storeConfigData(data) {
        return { type: constants.APP_CONFIGURATION, data };
    }



    function checkBrowserSupport(app) {

        try {
            new Function("(a = 0) => a");
            console.log("browser supported ES6.........");
            return true;
        } catch (err) {
            console.log("browser not supported ES6.........");
            return false;
        }

    }



    function getDeviceType() {
        var a = navigator.userAgent || navigator.vendor || window.opera;
        var check = 'desktop';
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge|maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
            check = 'mobile'
        };
        return check;
    };


    function renderApplicationError(app) {
        let appId = app.getSetting('appid');

        console.log('init', appId, 'rendering application error...');

        return app.ready().then(function() {
            let deferred = new $.Deferred();

            app.initRiot();

            setTimeout(function() {
                RiotBus.trigger("layout.showError", 'Error loading application', [
                    'There was an error loading the application. Please call customer support for assistance.'
                ], null, null, true);
            }, 250);

            console.log('init', appId, 'application error rendered');

            return deferred.resolve(app).promise();
        });
    }

    function isFeatureEnabled(feature) {
        let featureFlagsEnabled = getSetting('featureFlagsEnabled');
        return (!feature || !featureFlagsEnabled || !has(this.features, feature)) || (this.features && !!this.features[feature]);
    }


    function processUrl(urlFragment, pathVars) {
        // Process path variables
        if (!isEmpty(pathVars)) {
            urlFragment = MDTApi.processPathVariables(urlFragment, pathVars);
        }

        let url = '';

        // Given url fragment is starting by a pathname. E.g.: /apps/eservices/
        if (urlFragment.substring(0, 1) === '/') {
            // Eg. of recomposed URL => 'http:' + '//' + 'medtronic.local' + '/apps/eservices/#/order-approval/00025017'
            url = window.location.protocol + '//' + window.location.host + urlFragment;
        }

        // Given url fragment is starting by a hash. E.g.: #/order-approval/00025017
        else if (urlFragment.substring(0, 1) === '#') {
            // Eg. of recomposed URL =>  'http:' + '//' + 'medtronic.local' + '/apps/eservices/' + '#/order-approval/00025017'
            url = window.location.protocol + '//' + window.location.host + window.location.pathname + urlFragment;
        }

        // Given url fragment is starting by search term. E.g.: ?hello=world#/order-approval/00025017
        else if (urlFragment.substring(0, 1) === '#') {
            // Eg. of recomposed URL =>  'http:' + '//' + 'medtronic.local' + '/apps/eservices/' + '?hello=world#/order-approval/00025017'
            url = window.location.protocol + '//' + window.location.host + window.location.pathname + urlFragment;
        } else {
            // Given url fragment is starting with a valid protocol
            let re = /([a-z]*:)/;
            let m = re.exec(urlFragment);

            if (m && m.length > 1) {
                url = urlFragment;
            }

            // Not recognized URL format
            else {
                console.error('Not recognized URL format: ' + urlFragment);
                url = window.location.href;
            }

        }

        return url;
    }

    function goto(url, pathVars) {
        if (url) {
            window.location.href = processUrl(url, pathVars);
        }

    }

    function getQueryStringParam(key, uri, mustDecodeUriComponent) {
        if (mustDecodeUriComponent !== false) {
            mustDecodeUriComponent = true;
        }

        let href = uri ? uri : window.location.href;
        let reg = RegExp(key, 'g'); //new RegExp('[?&]' + key + '=([^&#\/]*)', 'i');
        let string = reg.exec(href) || false;
        if (!string) {
            return false;
        }
        if (mustDecodeUriComponent) {
            return isNull(string) ? null : decodeURIComponent(string[1]);
        } else {
            return isNull(string) ? null : string[1];
        }

    }

    function isFeatureVersion(featureName, version) {
        return (dispatch, getState) => {
            let features = getState().bootDetails.features;
            let appid = MDTSetting.appid;
            if (features.hasOwnProperty(appid) && features[appid].hasOwnProperty(featureName)) {
                return features[appid][featureName] === version;
            } else if (features.hasOwnProperty('default') && features.default.hasOwnProperty(featureName)) {
                return features['default'][featureName] === version;
            } else {
                console.error('Feature not found');
                return false;
            }
        }

    }

    function launchLogin() {

        return (dispatch, getState) => {

            let redirectMyorder = localStorage.getItem('myordersReferer');
            sessionStorage.setItem('referrer', window.location.href);
            if (!loginPopin) {
                loginPopin = true;
                if (!isNull(redirectMyorder) && redirectMyorder !== '' && redirectMyorder !== 'undefined') {
                    goto(getSetting('links.login') + '?myorderRedirect=' + redirectMyorder);
                } else {
                    goto(getSetting('links.login'));
                }
            }
        }
    }

    function getTimeZone() {
        return (dispatch, getState) => {

        }
        // return this.stores.me.getUser().zoneinfo;
    }

    function storeWishListId(data) {
        return { type: constants.USER_WISHLIST_ID_NAME, data };
    }

    function storeWishCount(data) {
        return { type: constants.USER_WISHLIST_COUNT, data };
    }

    function fetchWishlist(resolve) {
        return (dispatch, getState) => {
            const state = getState();
            let defaultCartType = get(state, 'formConfig.featureConfiguration.DefaultCartType.configuration.cartType', 'DEFAULT');
            MDTApi.setDefaultPathVar("defaultCartType", defaultCartType);
            return MDTApi.call('api.wishlist.cartId', {
                method: 'GET',
                successCallback: function(data) {
                    dispatch(storeWishListId(data[0]));
                    dispatch(loadWishlistCount(data[0].wishListId));
                    //dispatch(loadWishlist(data[0].wishListId));
                    resolve && resolve();
                }

            }, {}, getSetting('countLoader', true));

        }
    }

    function saveWishlistData(data) {
        return { type: constants.USER_WISHLIST_ENTRIES, data };
    }

    function loadWishlistCount() {
        return (dispatch, getState) => {
            dispatch(MDTApp.getResourceAccess('Returns', 'Read')) && dispatch(MDTApp.getResourceAccess('ReturnProducts', 'Feature')) && dispatch(getReturnsCart());
            MDTApi.setDefaultPathVar("cartid", getState().wishList.wishListId);
            return MDTApi.call('api.wishlist.cartCount', {
                method: 'GET',
                successCallback: function(data) {
                    dispatch(storeWishCount(data));
                }

            },{}, getSetting('countLoader', true));

        }
    }

    function loadWishlist() {
        return (dispatch, getState) => {
            MDTApi.setDefaultPathVar("cartid", getState().wishList.wishListId);
            return MDTApi.call('api.wishlist.cartItems', {
                method: 'GET',
                successCallback: function(data) {
                    dispatch(saveWishlistData(data));
                }

            });

        }
    }

    function logout(refreshToken) {
        let data = {
            token: sessionStorage.getItem('apiRefreshToken'),
            token_type_hint: 'refresh_token',
            client_id: 'mdtcJs',
            client_secret: 'medtronic'
        };

        data = createQueryStringParam(data);

        return MDTApi.call('openIdConfig.revocation_endpoint', {
            method: 'POST',
            data: data,
            headers: { 'Content-Type': 'multipart/form-data' },
            successCallback: function(data) {
                localStorage.removeItem("customer");
                sessionStorage.setItem('isRolesCountMax', "false")
                sessionStorage.removeItem('allEventsStore');
                sessionStorage.removeItem('allPageLoadData');
                let redirectMyorder = localStorage.getItem('myordersReferer');
                if (!isNull(redirectMyorder) && redirectMyorder !== '' && redirectMyorder !== 'undefined') {
                    MDTApp.goto(MDTApp.getSetting('links.login') + '?myorderRedirect=' + redirectMyorder);
                } else {
                    MDTApp.goto(MDTApp.getSetting('links.login'));
                }
            }

        });

    }

    function updateMDTSettings(name, data) {
        let updateSettings = {};
        updateSettings[name] = data;
        MDTSetting = mergeDeep(MDTSetting, updateSettings);
    }

    function updateCheckoutData(data) {
        return (dispatch, getState) => {
            dispatch(saveCheckoutData(data));
        }
    }

    function setLoginData(data) {
        return (dispatch, getState) => {
            new Promise(function(resolve, reject) {
                handleRefreshSuccess(data, dispatch, getState, resolve)
                restartRefreshTimer(dispatch, getState, resolve);
            }).then(function(getState) {
                const appId = getState().meDetails.user.defaultApp.toLowerCase();
                const ssoCheck = getState().meDetails.user.sso == 'True' ? true : false;
                const decodedAccessToken = jwt_decode(localStorage.getItem('apiToken'));
                const isInternal = getState().meDetails.user.isinternal;
                const me = getState().meDetails && getState().meDetails.meState, isLoggedIn = me.LOGGED_IN;
                isLoggedIn && idleLogout();
                // getSetting('getMessagesEnabled', true) && dispatch(getMessages());

                if((decodedAccessToken.password == "must_change_now") && (isInternal != "True")){
                    dispatch({ type: 'USERPREFERENCES', payload: { must_change_now : true } })
                }
                else if (appId != 'portal' && ( decodedAccessToken.password != "must_change_now") || isInternal == "True") {
                    if(ssoCheck){
                        dispatch(MDTApp.sso());
                    }else{
                        const appLink = getState().meDetails.user.appLink;
                        goto(appLink);
                    }

                }
            })

        }
    }

    function saveCheckoutData(data) {
        return { type: constants.CHECKOUT_ITEMS_LIST, data };
    }

    export function saveScreenOverlay(data) {
        return { type: constants.GET_SCREEN_OVERLAY, data };
    }

    function isMobile() {
        let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        return width < constants.TABLET_WIDTH;
    }

    function isTablet() {
        let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        return width >= constants.TABLET_WIDTH && width < constants.DESKTOP_WIDTH;
    }

    function isMobileOrTablet() {
        let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        return width < 1024;
    }

    function scrollIntoView(el) {
        if (!el) return;

        //el.offsetParent.offsetParent.offsetHeight
        let behavior = { top: 0, left: 0, behavior: "smooth" };

        //window.scrollTo(behavior);
        el.scrollIntoView({ block: 'end', behavior: 'smooth' });
    }

    function isDesktop() {
        let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        return width >= constants.DESKTOP_WIDTH;
    }


    function setTileAction(data) {
        return { type: constants.PORTAL_TILES, data };
    }


    function sso(redirectURL, url) {
        return (dispatch, getState) => {
            if( window.refreshTokenFlag  && SSOclick ){
                SSOclick = false;
                console.log('redirecting');
                let userId = getState().meDetails.user.sub || [];
                MDTApp.myloginRedirect(userId,redirectURL, url);
            }else{
                window.setTimeout(MDTApp.sso, 1000);
                }
        };
    }


    function myloginRedirect(userId, redirectURL, url) {
        let token = "Bearer " + localStorage.getItem('apiToken'),
                redirectionLink = MDTApp.getSetting('myorderurl') || window.t('myorders.ssologin.'+window.location.host.split('.')[0]) || "";
            let data = {
                'userId' : userId,
                'token': encodeURIComponent(token),
                'refreshToken': encodeURIComponent(sessionStorage.getItem('apiRefreshToken')) || '',
                'language': "en_US"
                }
            if(redirectURL) {
                data.redirectURL = url;
            }
            MDTApp.postSSOFrom (redirectionLink,data);
    }

    function postSSOFrom(path, params, method) {
        method = method || "post";

        let form = document.createElement("form");
        form.setAttribute("method", method);
        form.setAttribute("action", path);

        for(let key in params) {
            if(params.hasOwnProperty(key)) {
                let hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", key);
                hiddenField.setAttribute("value", params[key]);

                form.appendChild(hiddenField);
            }
        }

        document.body.appendChild(form);
        form.submit();
    }


    export const MDTApp = {
        registerSettings: window.MDTApp.registerSettings,
        initBootstrap,
        mergeDeep,
        getSettingObjectByKey,
        isAvilable,
        goto,
        authenticate,
        getSetting,
        createQueryStringParam,
        getResourceAccess,
        isFeatureVersion,
        getTimeZone,
        showNotification,
        fetchWishlist,
        loadWishlist,
        loadWishlistCount,
        updateMDTSettings,
        registerAppApiSettings,
        processUrl,
        logout,
        updateCheckoutData,
        saveScreenOverlay,
        setLoginData,
        getDeviceType,
        isMobile,
        isTablet,
        isMobileOrTablet,
        scrollIntoView,
        isDesktop,
        postSSOFrom,
        myloginRedirect,
        sso,
        setTileAction,
        whitelistedUrl
    }
